import $ from './jquery-3.5.1.min.js';
window.$ = window.jQuery = $;


require('./jquery.rateit.min.js');
require('./bootstrap.min.js');
// import AOS from './aos.js';
// window.AOS = window.AOS = AOS;

require('./custom.js');


